<template>
    <div class="cont">
    <v-row no-gutters justify="center">
      <v-col xs="12" sm="2" md="2" style="justify-content:center">
        <v-img
          style="margin 0 auto 15px"
          src="../assets/logoideal.png"
          height="150px"
          contain
        ></v-img>
      </v-col>
      <v-col v-if="this.bred > 600" offset-sm="1" sm="2" xs="12">
        <h2 class="font-weight-light text-center" style="text-align:center; margin-top:30px">19.01.20</br>PARIS FRANCE</h2>
      </v-col>
      <v-col v-if="this.bred > 600" offset-sm="3" sm="2" xs="12">
        <h4 class="font-weight-light display-1 text-center" style="text-decoration: underline; margin-top:30px"><a @click="dialog = true" style="color:#fff">RSVP</a></h4>
      </v-col>
    </v-row>
      <v-col xs="6" v-if="this.bred < 600">
        <h2 class="font-weight-light text-center">19.01.20</br>PARIS FRANCE</h2>
      </v-col>
      <v-row>
      <v-col offset-sm="3" sm="2" xs="6">
      <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-form ref="form">
              <v-card-title>
                <span class="headline">Attendee info</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" xs="6" sm="6" md="6">
                      <v-text-field label="Surname *" :rules="[rules.required]" v-model="firstname" required></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="6">
                      <v-text-field label="Lastname *" :rules="[rules.required]" v-model="lastname" required></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field label="Email *" v-model="email" :rules="[rules.required, rules.email]" required></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="6">
                      <v-text-field v-model="phone" label="Phone number"></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="6" sm="6" md="6">
                      <v-text-field v-model="phonemodel" label="Phone model"></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12">
                      <v-textarea
                        name="input-7-1"
                        label="Allergies"
                        v-model="allergies"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
                <small>* required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                <v-btn color="blue darken-1" text @click="rsvp">Attend</v-btn>
              </v-card-actions>
            </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="succ" persistent max-width="600px">
            <v-card
              class="mx-auto"
              color="success"
              dark
              max-width="400"
            >
              <v-card-title>
                <span class="display-1 font-weight-light text-center ">Congratulations!</span>
              </v-card-title>

              <v-card-text class="headline font-weight-regular">
                You have been signed up for our event in Paris, we hope you'll have a great time.
              </v-card-text>

              <v-card-actions>
                <v-btn color="white" @click="succ = false" text>Close</v-btn>
              </v-card-actions>
            </v-card>
              </v-dialog>
      </v-col>
    </v-row>

    <v-row class="vid" >
      <v-col offset-sm="2" sm="8" cols="12">
        <v-img v-if="this.bred > 600" aspect-ratio="2.2" src="../assets/LeonieIOS70.jpg" style="width:120vw; margin: 0 -% 0"></v-img>
        <v-img v-else aspect-ratio="0.9" src="../assets/LeonieIOS70.jpg" style="width:120vw; margin: 0 -% 0"></v-img>
      </v-col>

      <v-col sm="1" class="sd" style="margin-bottom:40px;">
        <a href="https://www.instagram.com/idealofsweden" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/instagram.svg" height="20" width="20"></v-img>
        </a>
        <a href="https://twitter.com/idealofsweden" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/twitter.svg" height="20" width="20"></v-img>
      </a>
      <a href="https://www.facebook.com/idealofsweden" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/fb.svg" height="20" width="20"></v-img>
      </a>
      <a href="https://www.youtube.com/channel/UCZOU4umLQG3Wd1J1Pl-hgxA" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/youtube.svg" height="20" width="20"></v-img>
      </a>
      <a href="https://www.linkedin.com/company/ideal-of-sweden" target="blank">
        <v-img style="margin-bottom:35px" src="../assets/linkedin.svg" height="20" width="20"></v-img>
      </a>
      <p style="writing-mode: vertical-rl;text-orientation: mixed;" class="font-italic font-weight-light">@leoniehanne</p>
      </v-col>


      <v-col md="1" class="d-flex d-sm-none beBack">
        <a href="https://www.instagram.com/idealofsweden" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/instagram.svg" height="20" width="20"></v-img>
        </a>
        <a href="https://twitter.com/idealofsweden" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/twitter.svg" height="20" width="20"></v-img>
      </a>
      <a href="https://www.facebook.com/idealofsweden" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/fb.svg" height="20" width="20"></v-img>
      </a>
      <a href="https://www.youtube.com/channel/UCZOU4umLQG3Wd1J1Pl-hgxA" target="blank">
        <v-img style="margin-bottom:15px" src="../assets/youtube.svg" height="20" width="20"></v-img>
      </a>
      <a href="https://www.linkedin.com/company/ideal-of-sweden" target="blank">
        <v-img style="margin-bottom:35px" src="../assets/linkedin.svg" height="20" width="20"></v-img>
      </a>
      <v-spacer></v-spacer>
      <p class="font-italic font-weight-light">@leoniehanne</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" >
        <p class="bottext text-center subtitle-1">19.01.20</br>DIRECTED BY @leoniehanne</br>IN PARTNERSHIP W/iDealOfSweden</p>
      </v-col>
    </v-row>
    <v-row v-if="this.bred < 600">
    <v-col xs="12">
      <h4 class="font-weight-light display-1 text-center" style="text-decoration: underline; text-align:center"><a @click="dialog = true" style="color:#fff">RSVP</a></h4>
    </v-col>
  </v-row>
    <v-row>
      <v-col xs="12">
        <p style="margin: 50px 10% 100px; font-size:60px !important; line-height:1" class="d-flex d-sm-none font-weight-thin">UN HOMMAGE À PARIS</p>
        <p style="margin: 300px 10% 200px; font-size:100px !important; line-height:1" class="display-3 d-none d-sm-flex font-weight-thin">UN HOMMAGE À PARIS</p>
      </v-col>
    </v-row>
    <div v-if="this.bred > 600">
    <v-row>
      <v-col sm="6" style="padding-left: 10%;padding-right:10% margin: 50vw 0 50vw">
        <p class="headline" style="margin-top: 50%; height: 50vw">iDeal of Sweden and Leonie Hanne invites you to celebrate the new collection 'Un Hommage à Paris'. The collection is a tribute to Paris and a reflection of Leonie - Fashionable, feminine and playful!</p>
      </v-col>
      <v-col sm="6">
        <v-img  aspect-ratio="0.9" style="height: 50vw;" src="https://d1uc8an4wd3bah.cloudfront.net/Collaboration/pics/Leonie2.jpg"></v-img>
      </v-col>
      <v-col sm="6">
        <v-img  aspect-ratio="0.6" style="height: 50vw;" src="https://d1uc8an4wd3bah.cloudfront.net/Collaboration/pics/Leonie1.jpg"></v-img>
      </v-col>
      <v-col sm="6" style="margin-top: 20%; height: 50vw">
        <p class="headline" >Join us for an intimate get-together at le Salon de Famille at Shangri-La in the heart of Paris - on the 19th of January at 17.00.</p>
        <p class="headline font-italic">Shangri-La Hotel</br> 10 Avenue d'Iéna</br>75116 Paris, France</p>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-row>
      <v-col xs="12" sm="6" style="padding-left: 10%;padding-right:10%">
        <p class="headline">iDeal of Sweden and Leonie Hanne invites you to celebrate the new collection 'Un Hommage à Paris'. The collection is a tribute to Paris and a reflection of Leonie - Fashionable, feminine and playful!</p>
      </v-col>
      </v-row>
      <v-img transition="scroll-x-transition" src="https://d1uc8an4wd3bah.cloudfront.net/Collaboration/pics/Leonie2.jpg"></v-img>
      <v-row>
      <v-col xs="12" sm="6" style="padding-left: 10%;padding-right:10%; margin: 50vw 0 50vw">
        <p class="headline">Join us for an intimate get-together at le Salon de Famille at Shangri-La in the heart of Paris - on the 19th of January at 17.00.</p>
        <p class="headline font-italic">Shangri-La Hotel</br> 10 Avenue d'Iéna</br>75116 Paris, France</p>
      </v-col>
    </v-row>
    <v-img  aspect-ratio="0.6" src="https://d1uc8an4wd3bah.cloudfront.net/Collaboration/pics/Leonie1.jpg"></v-img>
  </div>

  <v-container>
  <v-row justify="center">
    <v-col sm="12" style="margin-top:300px">
      <div class="font-weight-light white--text mb-2 display-2 text-center">Hope to see you there.</br></br>Love xx Leonie & Team iDeal</div>
      <h2 class="font-weight-light display-2 text-center" style="text-decoration: underline;"><a @click="dialog = true" style="color:#fff">RSVP</a></h2>
    </v-col>
  </v-row>
  <v-row style="margin-top:300px">
    <v-col cols="12" xs="4" sm="2" >
      <v-btn class="ma-2" @click="$vuetify.goTo(target, options)" outlined large fab color="white">
        <v-icon>mdi-navigation</v-icon>
       </v-btn>
    </v-col>
    <v-col cols="12" xs="4" sm="8" >
      <p class="text-center subtitle-1">19.01.20</br>DIRECTED BY @leoniehanne</br>IN PARTNERSHIP W/iDealOfSweden</p>
    </v-col>
    <v-col  cols="12" xs="4" sm="2">
      <v-img
        class="mx-auto mt-6"
        src="../assets/logoideal.png"
        width="100%"
        height="80%"
        contain
      ></v-img>
    </v-col>
  </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'

export default {

  name: 'HelloWorld',
  data () {
    return {
      dialog: false,
      succ: false,
      firstname: null,
      lastname: null,
      phonemodel: null,
      allergies: null,
      bred: null,
      email: null,
      phone: null,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  created() {
    this.bred = window.innerWidth
  },
  methods: {
  rsvp () {
          axios({
            url: 'https://hooks.zapier.com/hooks/catch/5015474/o6s9atf/',
            method: 'post',
            params: {
              "firstname": this.firstname,
              "lastname": this.lastname,
              "email": this.email,
              "phone": this.phone,
              "phonemodel": this.phonemodel,
              "allergies": this.allergies
              }
              }).then(response => {
            console.log(response)
            this.dialog = false
            this.succ = true
          })
      .catch(function (error) {
        console.log(error);
      });
  }
}
};
</script>
<style>
@media screen and (min-height: 1079px) {
  .vid {
    margin-top: 100px;
  }
}
@media screen and (max-height: 1079px) {
  .vid {
    margin-top: 20px;
  }
}
@media screen and (max-width: 600px) {
  .bottext {
    line-height:1.2; margin-top:100px !important;
  }
}
.bottext {
  line-height:1.2; margin-top:60px; padding-bottom: 40px;
}
@media screen and (min-width: 500px) {
  .cont {
    padding: 30px 15px 0;
  }
}
@media screen and (max-width: 600px) {
  .sd {
    display: none;
  }
}
@media screen and (min-width: 600px) {
  .big {
    font-size: 200px;
  }
}
.cont {
  padding: 30px 20px 0;
}
.beBack a {
  margin: 0 30px 0;
}
body {
  font-family: GillSans;
}
.picp p {
  display: inline;
}
@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-SemiBoldItalic.woff2') format('woff2'),
        url('GillSans-SemiBoldItalic.woff') format('woff');
    font-weight: 600;
    font-style: italic;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-SemiBold.woff2') format('woff2'),
        url('GillSans-SemiBold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-LightItalic.woff2') format('woff2'),
        url('GillSans-LightItalic.woff') format('woff');
    font-weight: 300;
    font-style: italic;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-UltraBold.woff2') format('woff2'),
        url('GillSans-UltraBold.woff') format('woff');
    font-weight: 800;
    font-style: normal;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-Italic.woff2') format('woff2'),
        url('GillSans-Italic.woff') format('woff');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans.woff2') format('woff2'),
        url('GillSans.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-Light.woff2') format('woff2'),
        url('GillSans-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-BoldItalic.woff2') format('woff2'),
        url('GillSans-BoldItalic.woff') format('woff');
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: 'Gill Sans';
    src: url('GillSans-Bold.woff2') format('woff2'),
        url('GillSans-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}
</style>
